import { useTranslation } from 'react-i18next';
import { DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';

import { DeleteActionIconButton } from '@/components/actions';
import { ActionButton, type ActionButtonProps, type ActionIconButtonProps } from '@/components/buttons';
import {
  useNomenclatureStoreActions,
  useNomenclatureStoreContextWindowsState,
  useNomenclatureStoreIsContextWindowsVisible,
} from '@/components/nomenclature/useNomenclatureStore';
import { useShortcut } from '@/shared/hooks/useShortcut';

// ----------------------------------------------------------------------

export const NomenclatureMainDeleteButton = (props: ActionIconButtonProps) => {
  const { disabled } = props;

  const isContextWindowsVisible = useNomenclatureStoreIsContextWindowsVisible();
  const canOpenDeleteDialog = !disabled && !isContextWindowsVisible;

  const { openDeleteDialog } = useNomenclatureStoreActions();

  useShortcut({
    combination: 'ctrl + -',

    onPressed: () => {
      if (canOpenDeleteDialog) {
        openDeleteDialog();
      }
    },
  });

  return <DeleteActionIconButton {...props} onClick={openDeleteDialog} />;
};

// ----------------------------------------------------------------------

export const NomenclatureInlineDeleteButton = (props: ActionIconButtonProps) => {
  const { onClick } = props;

  const { openDeleteDialog } = useNomenclatureStoreActions();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    openDeleteDialog();
  };

  return <DeleteActionIconButton {...props} onClick={handleClick} />;
};

// ----------------------------------------------------------------------
// MODAL BUTTON

export const NomenclatureModalDeleteButton = (props: ActionButtonProps) => {
  const { disabled } = props;
  const { t } = useTranslation('nomenclature-page');

  const { isDuplicateModalVisible, isDeleteDialogVisible } = useNomenclatureStoreContextWindowsState();
  const canOpenDeleteDialog = !disabled && !isDuplicateModalVisible && !isDeleteDialogVisible;

  const { openDeleteDialog } = useNomenclatureStoreActions();

  useShortcut({
    combination: 'ctrl + -',

    onPressed: () => {
      if (canOpenDeleteDialog) {
        openDeleteDialog();
      }
    },
  });

  return (
    <ActionButton
      color="error"
      startIcon={<DeleteOutlineIcon fontSize="small" />}
      onClick={openDeleteDialog}
      {...props}
    >
      {t('actions.delete')}
    </ActionButton>
  );
};
